export { type LanguageMetadata, accents, ttsLanguages, ttsLanguagesMap } from "@mw/shared/languagesAndAccents";
import { type LanguageOrAccent, asrLanguages, languages, ttsLanguagesAndAccents } from "@mw/shared/languagesAndAccents";
export { type LanguageOrAccent, asrLanguages, languages };

export const languageLabelsAndSlugs = languages.map(language => ({ label: language.label, slug: language.slug }));

export const allLanguagesAndAccents: LanguageOrAccent[] = ttsLanguagesAndAccents;

export const getLanguageOrAccent = (key: string): LanguageOrAccent => {
  const languageOrAccent = allLanguagesAndAccents.find(
    languageOrAccent => languageOrAccent.value === key,
  ) as LanguageOrAccent;
  if (!languageOrAccent) {
    throw new Error(`Language or accent not found: ${key}`);
  }
  return languageOrAccent;
};

export const getASRLanguage = (key: string): LanguageOrAccent => {
  const language = asrLanguages.find(language => language.value === key);
  if (!language) {
    throw new Error(`ASR Language not found: ${key}`);
  }
  return language;
};
